<div class="main-card mb-3 card">
  <div class="card-body">
    <div class="title-block mb-3">
      <i class="fa fa-fw" [title]="'TR_GOBACK' | translate" (click)="mainService.goBack('document')"></i>
      <h5 class="card-title">{{ 'TR_PRINT_OUT' | translate }} {{ 'TR_DOCUMENT' | translate }}</h5>
    </div>
    <iframe id="ifmcontentstoprint" style="height: 0px; width: 0px; position: absolute"></iframe>
    <kendo-pdf-export #pdf forcePageBreak=".page-break">
      <div #contentToConvert *ngIf="documentData" id="doc">
        <div *ngIf="!documentData.documentTemplateId" class="print" [innerHTML]="documentData.data"></div>
        <div *ngIf="documentData.documentTemplateId" class="document-container">
          <app-template-document-view [templateContent]="documentData.data"
            [templateId]="documentData.documentTemplateId"></app-template-document-view>
        </div>
      </div>
    </kendo-pdf-export>

    <button type="button" class="mt-2 btn btn-primary" (click)="print()">{{ 'TR_PRINT_OUT' | translate }}</button>
    <button #btn kendo-button type="button" class="ml-2 mt-2 btn btn-primary" (click)="pdf.saveAs(documentName)">{{ 'TR_DOWNLOAD' | translate }} PDF</button>
  </div>
</div>